<template>
 
     <v-content class="mt-7 ml-7 mr-7">
    <v-container grid-list-md class="pb-0">
  <v-data-table :headers="headers" :items="desserts" sort-by="calories" class="elevation-1" >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Catálogo de Fracciones</v-toolbar-title>
        <v-divider
          class="mx-3"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="800px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">Agregar Fraccion </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm3 d-flex>
                    <v-text-field v-model="editedItem.numFraccion" label="Fracción">{{editedItem.idFraccion}}</v-text-field>
                  </v-flex>
                  <v-flex xs12 sm9 d-flex> 
               
             <v-select :items="respddl" item-text="tipoFraccion"  label="Tipo de fraccion" outlined></v-select>
                  
                  </v-flex>
                   <v-flex d-flex xs12 sm12 md12>
                      <v-textarea filled auto-grow v-model="editedItem.fraccion"  label="Descripción" rows="2" row-height="20" ></v-textarea>
                    </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        edit
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
    </v-container>
     </v-content>
</template>


<script>
import axunidad from "axios";
import { async } from 'q';
  export default {
    data: () => ({
      
      dialog: false,
      headers: [
        
        { text: ' # Fraccion',   value: 'numFraccion' },
        { text: 'Fraccion',      value: 'fraccion' },
        { text: 'tipo fraccion', value: 'idTipoFraccion' },
        { text: 'Acción',       value: 'action', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        nombreUnidad: '',
        Siglas: 0,
        idUnidad: 0,
      },
      defaultItem: {
         nombreUnidad: '',
        Siglas: 0,
        idUnidad: 0,
      },
      respddl:[],
      items:[],
    }),
    

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva Fraccion' : 'Fraccion Unidad'
      },

    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      let self = this;
      self.initialize();
     
    },

    methods: {
  
      initialize () {
        let self = this;
      

        self.$store.state.services.fraccionService
        .getCatFraccion()
        .then(r =>{
  
            this.desserts =r.data.data;
            
             //console.log( this.desserts);
          
        })
        
      self.ddlfraccion()
      },

        async editItem (item) {
       this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
         //console.log(this.editedItem);
         this.dialog = true
  
      },

      deleteItem (item) {
        const index = this.desserts.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

        save () {
       // console.log(this.editedItem);
       let selft = this;
        if (this.editedIndex > -1) {
    //Editar Unidad
           let self = this;
          Object.assign(this.desserts[this.editedIndex], this.editedItem)
          self.$store.state.services.fraccionService
            .updateFraccion(self.editedItem)
            .then(r => {
              r.data
              })   
             .catch(error => console.error('Error:', error))
             .then(response => console.log('Success:', response));         
        } else {
    //Guardar Unidad   
          this.desserts.push(this.editedItem)
           let self = this;
              self.$store.state.services.fraccionService
              .addFraccion(self.editedItem)
              .then(r => {
               self.initialize();
              })
             .catch(error => console.error('Error:', error))
             .then(response => console.log('Success:', response));
        }
        this.close()
      },
//ddl tipo de fraccion 

        ddlfraccion () {
           let self = this;
       self.$store.state.services.fraccionService
        .ddlTfraccion()
        .then(c =>{
  
        this.respddl =c.data.data;
           this.respddls= Object.assign({},this.respddl);
             console.log(this.respddls);
              console.log(this.respddl.idTipoFraccion);
        })
      
      },
    },
  }
</script>

